import styled from 'styled-components';

export const StyledPageWrapper = styled.div`
  height: 100vh;
  min-height: 40rem;
  display: flex;
  flex-direction: column;

  & > .ant-layout-header {
    flex-shrink: 0;
  }
`;

export const StyledSpinnerWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .ant-spin-nested-loading,
  .ant-spin-container {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  flex: 1;
  min-height: 0;
  padding: 1.5rem 2.5rem;
`;

export const StyledActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const StyledVariablesSidebar = styled.div`
  flex: 0 0 23rem;
  width: 23rem;
`;
